module.exports = __webpack_public_path__ + "img/XAI4.e265d410.jpg";